import { structuralEngineeringSchema, createStructuralEngineeringResponseSchema, getStructuralEngineeringResponseSchema, GetStructuralEngineeringFilesResponseSchema, getStructuralEngineeringResultsResponseSchema, structuralEngineeringResultSchema, structuralEngineeringResultsDashboardSchema, } from '@consigli/types';
import { createTransformer, createParams, mapToSnakeCase, } from './shared/base-api';
export const structuralEngineeringApiEndpoints = (builder, coreApiBaseUrl) => ({
    getStructuralEngineering: builder.query({
        query: ({ projectId, structuralId }) => `${coreApiBaseUrl}/projects/${projectId}/structural/${structuralId}/`,
        providesTags: ['StructuralEngineering'],
        transformResponse: createTransformer(structuralEngineeringSchema, 'getStructuralEngineering'),
    }),
    getStructuralEngineeringFiles: builder.query({
        query: ({ projectId, structuralId, page, pageSize, search }) => {
            const params = createParams({ page, pageSize, search });
            return {
                url: `${coreApiBaseUrl}/projects/${projectId}/structural/${structuralId}/files/`,
                method: 'GET',
                params: mapToSnakeCase(params),
            };
        },
        providesTags: ['StructuralEngineeringFiles'],
        transformResponse: createTransformer(GetStructuralEngineeringFilesResponseSchema, 'getStructuralEngineering'),
    }),
    getStructuralEngineerings: builder.query({
        query: ({ projectId, type }) => {
            const params = createParams({ type });
            return {
                url: `${coreApiBaseUrl}/projects/${projectId}/structural/`,
                method: 'GET',
                params: mapToSnakeCase(params),
            };
        },
        providesTags: ['StructuralEngineering'],
        transformResponse: createTransformer(getStructuralEngineeringResponseSchema, 'getStructuralEngineering'),
    }),
    createStructuralEngineering: builder.mutation({
        query: ({ projectId, payload }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/structural/`,
            method: 'POST',
            body: mapToSnakeCase(payload),
        }),
        invalidatesTags: ['StructuralEngineering', 'Projects'],
        transformResponse: createTransformer(createStructuralEngineeringResponseSchema, 'CreateStructuralEngineering'),
    }),
    deleteStructuralEngineering: builder.mutation({
        query: ({ projectId, structuralEngineeringId }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/structural/${structuralEngineeringId}/`,
            method: 'DELETE',
        }),
        invalidatesTags: ['StructuralEngineering'],
    }),
    createStructuralEngineeringResult: builder.mutation({
        query: ({ projectId, structuralId, structuralResult }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/structural/${structuralId}/results/`,
            method: 'POST',
            body: mapToSnakeCase(structuralResult),
        }),
        invalidatesTags: ['StructuralEngineeringResults'],
        transformResponse: createTransformer(structuralEngineeringResultSchema, 'createStructuralEngineeringResult'),
    }),
    getStructuralEngineeringResults: builder.query({
        query: ({ projectId, structuralId, page, pageSize, search, type }) => {
            const params = createParams({ page, pageSize, search, type });
            return {
                url: `${coreApiBaseUrl}/projects/${projectId}/structural/${structuralId}/results/`,
                method: 'GET',
                params: mapToSnakeCase(params),
            };
        },
        providesTags: ['StructuralEngineeringResults'],
        transformResponse: createTransformer(getStructuralEngineeringResultsResponseSchema, 'getStructuralEngineeringResults'),
    }),
    getStructuralEngineeringResult: builder.query({
        query: ({ projectId, structuralId, resultId }) => `${coreApiBaseUrl}/projects/${projectId}/structural/${structuralId}/results/${resultId}/`,
        providesTags: ['StructuralEngineeringResults'],
        transformResponse: createTransformer(structuralEngineeringResultSchema, 'getStructuralEngineeringResults'),
    }),
    deleteStructuralEngineeringResult: builder.mutation({
        query: ({ projectId, structuralId, resultId }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/structural/${structuralId}/results/${resultId}/`,
            method: 'DELETE',
        }),
        invalidatesTags: ['StructuralEngineeringResults'],
    }),
    deleteStructuralEngineeringFile: builder.mutation({
        query: ({ projectId, structuralId, fileId }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/structural/${structuralId}/files/${fileId}/`,
            method: 'DELETE',
        }),
        invalidatesTags: ['StructuralEngineeringFiles'],
    }),
    addStructuralEngineeringFiles: builder.mutation({
        query: ({ projectId, structuralId, data }) => ({
            url: `${coreApiBaseUrl}/projects/${projectId}/structural/${structuralId}/`,
            method: 'PATCH',
            body: data,
        }),
        invalidatesTags: ['StructuralEngineeringFiles'],
    }),
    getStructuralEngineeringResultsDashboard: builder.query({
        query: ({ projectId, structuralId }) => {
            return {
                url: `${coreApiBaseUrl}/projects/${projectId}/structural/${structuralId}/results/dashboard/`,
                method: 'GET',
            };
        },
        transformResponse: createTransformer(structuralEngineeringResultsDashboardSchema, 'getStructuralEngineeringResultsDashboard'),
    }),
});
